import ENV from "../env";

const createTableOrder = async ({
  amount,
  products,
  orgId,
  tableId,
  tableNumber,
  tableName = "",
  creatorName = "",
  note = "",
}) => {
  if (!tableId) throw new Error("tableId is required");
  const response = await fetch(`${ENV.firebaseApiUrl}/orders/table-order`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      amount,
      products,
      orgId,
      tableId,
      tableNumber,
      tableName,
      creatorName,
      note,
    }),
  });

  const resData = await response.json();

  if (!response.ok) {
    throw new Error(resData.message || "Failed to create table order");
  }

  return resData.order;
};

export default createTableOrder;
